import React from "react";

import { HubTableTemplate } from "../../components";
import { useGetWorkOrderRoutingRoute } from "../../hooks";

import SubRoutesContextMenu from "./SubRoutesContextMenu";
import SubRoutingLabor from "./SubRoutingLabor";

export const SubRoutesTable = ({ routeId, isSmall = false }) => {
  const { data = [] } = useGetWorkOrderRoutingRoute(routeId);
  const rows = data?.map((g) => ({ id: g.id, items: g.routes }));

  const items = [
    {
      id: "station",
      label: "Station",
    },
    {
      id: "quantity",
      label: "Quantity",
    },
    {
      id: "completed",
      label: "Completed",
    },
    ...(isSmall
      ? []
      : [
          {
            id: "scrapped",
            label: "Scrapped",
          },
          {
            id: "plannedStartDate",
            label: "Planned Start",
          },
          {
            id: "plannedEndDate",
            label: "Planned End",
          },
        ]),
    {
      id: "startDate",
      label: "Actual Start",
    },
    {
      id: "endDate",
      label: "Actual End",
    },
  ];

  const keys = [
    {
      value: "station.label",
    },
    {
      value: "quantity",
      defaultValue: 0,
    },
    {
      value: "completed",
      defaultValue: 0,
    },
    ...(isSmall
      ? []
      : [
          {
            value: "scrapped",
            defaultValue: 0,
          },
          {
            value: "plannedStartDate",
            isDate: true,
          },
          {
            value: "plannedEndDate",
            isDate: true,
          },
        ]),
    {
      value: "startDate",
      isDate: true,
    },
    {
      value: "endDate",
      isDate: true,
    },
  ];

  const headerProps = { items, includeEnd: true, includeChevron: !isSmall };
  const bodyProps = {
    includeChevron: !isSmall,
    groups: rows,
    keys,
    ContextMenu: SubRoutesContextMenu,
    ...(isSmall ? {} : { RenderElement: SubRoutingLabor }),
    spacerProps: { sx: { backgroundColor: "hubColors.greyLighter" } },
    includeEnd: true,
  };

  const props = { headerProps, bodyProps };

  return (
    <HubTableTemplate {...props} sx={{ backgroundColor: "hubColors.white" }} />
  );
};

export default SubRoutesTable;
